import type {
  TAnalyticsData,
  TFailedConversationDetail,
  TFailedConversationMeta,
  TSessionAnalytics,
} from "@/types/TAnalytics";

export async function getAnalytics(days: number = 30): Promise<TAnalyticsData> {
  const response = await fetch(`/api/analytics?days=${days}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch analytics: ${response.status}`);
  }
  
  return response.json();
}

export async function getSessionAnalytics(days: number = 30): Promise<TSessionAnalytics> {
  const response = await fetch(`/api/heygen/session-analytics?days=${days}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch session analytics: ${response.status}`);
  }

  return response.json();
}

export async function getFailedConversations(days: number = 30): Promise<TFailedConversationMeta[]> {
  const response = await fetch(`/api/analytics/failed-conversations?days=${days}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch failed conversations: ${response.status}`);
  }
  const data = await response.json();
  return data.items ?? [];
}

export async function getFailedConversation(id: string): Promise<TFailedConversationDetail> {
  const response = await fetch(`/api/analytics/failed-conversations/${encodeURIComponent(id)}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch failed conversation: ${response.status}`);
  }
  return response.json();
}
